import React from 'react';
import { useQueryClient } from 'react-query';
import { Modal, Form } from 'antd';
import { roomQueryKeys } from '../../../queries/queryKeys';
import { getEditingRoomData } from '../../../utils/getEditingRoomData';
import useChangeRoomServicesMutation from '../../../mutations/useChangeRoomServicesMutation';
import ServicesSelectField from '../../formComponents/ServicesSelectField';

const ChangeRoomServices = ({ form, onCancel, visible, room }) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const queryClient = useQueryClient();

  const {
    mutateAsync: changeServicesMutateAsync,
    isLoading: isChangeServicesLoading,
  } = useChangeRoomServicesMutation({
    onSuccess: () => queryClient.invalidateQueries(roomQueryKeys(room?.id)),
  });

  const handleCancel = () => {
    resetFields();

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const data = getEditingRoomData(room);

        await changeServicesMutateAsync({
          room: data,
          companyServices: values.companyServices
            ? values.companyServices.map((serviceId) => ({
                id: serviceId,
              }))
            : [],
        });
        handleCancel();
      }
    });
  };

  return (
    <Modal
      visible={visible}
      title="Изменить список услуг"
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="Изменить"
      confirmLoading={isChangeServicesLoading}
      destroyOnClose
      maskClosable={false}
    >
      <Form id="changeServicesForm">
        <ServicesSelectField
          form={form}
          hasLabel={false}
          getPopupContainer={() =>
            document.getElementById('changeServicesForm')
          }
          editingRoom={room}
        />
      </Form>
    </Modal>
  );
};

const ChangeRoomServicesModal = Form.create({ name: 'change_room_services' })(
  ChangeRoomServices
);

export default ChangeRoomServicesModal;
